<template>
  <div
    class="list-view-toggle-tab"
    v-bind:style="{ '--listview-cols': listViewCols }"
    v-on:click="$_emitToggleEvent"
  >
    <input
      type="checkbox"
      v-bind:id="inputId"
      v-bind:checked="value"
      v-on:change="$emit('change', $event.target.value)"
      class="accordion"
    />
    <img src="@/assets/ifield/img_arrow_right.png" class="tab-arrow" />
  </div>
</template>

<script>
export default {
  name: 'appListViewToggleTab',
  props: {
    /**
     * チェック状態
     * @model
     */
    value: {
      type: Boolean,
      default: true,
    },
    /**
     * ListViewのcolsの数
     */
    listViewCols: {
      type: Number,
      required: true,
    },
    /**
     * idにつけるprefix
     */
    idPrefix: {
      type: String,
      default: '',
    },
  },
  computed: {
    /**
     * 隠しチェックボックスのID
     * @type {String}
     */
    inputId: function () {
      return `${this.idPrefix}-list-view-toggle-tab`
    },
  },
  mounted: function () {
    this.$log.debug('listview toggletab mounted!')
  },
  methods: {
    /**
     * トグルされたイベントを発行する
     */
    $_emitToggleEvent: function () {
      this.$emit('listview-toggletab-toggled', this.checked)
    },
  },
}
</script>

<style lang="scss" scoped>
.list-view-toggle-tab {
  --listview-cols: 4;

  width: 1.6rem;
  height: 4rem;
  background-color: #ffffff;
  opacity: 0.9;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.24);
  cursor: pointer;

  display: flex;
  justify-content: flex-start;
  align-items: center;

  .tab-arrow {
    height: 40px;
    margin-left: -6px;
    transform-origin: 45% 50%;
  }
}

[id$='-list-view-toggle-tab'] {
  display: none;

  &:checked ~ .tab-arrow {
    -webkit-transform: rotate(-180deg);
    -moz-transform: rotate(-180deg);
    -ms-transform: rotate(-180deg);
    -o-transform: rotate(-180deg);
    transform: rotate(-180deg);
  }
}
</style>
